import { render, staticRenderFns } from "./MemberAreaModules.vue?vue&type=template&id=beb2684e&"
import script from "./MemberAreaModules.vue?vue&type=script&lang=js&"
export * from "./MemberAreaModules.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaModules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports